import { BYO_MARKET_NO_ROWS, CATEGORIES } from '../constants';
const globalConfig = (window.WH && window.WH.byo) || {
    eventId: process.env.EVENTID || '',
    locale: process.env.LOCALE || 'en-gb',
    dataServiceUrl: process.env.DATA_SERVICE_URL || '',
    betslipServiceEndpoint: process.env.BETSLIP_SERVICE_ENDPOINT || '',
    minimumSelections: 2,
    maximumSelections: 12,
    defaultOpenAccordions: 0,
    locationState: 'BYO_APP',
    tag: 'byo',
    platform: process.env.PLATFORM,
    useBYOFreedom: process.env.FREEDOM === 'true',
    byoInPlay: process.env.INPLAY === 'true',
    highlightPriceChangeTime: 2000,
    showImpactSub: process.env.SHOW_IMPACT_SUB === 'true',
};
const localConfig = {
    maximumLegPartsBySport: JSON.parse(process.env.MAXIMUM_LEG_PARTS_BY_SPORT || '{}'),
};
const getConfig = () => (Object.assign(Object.assign({}, globalConfig), localConfig));
const disabledSiblingsButtonsOnCategories = [
    CATEGORIES.RESULT,
    CATEGORIES.BOTH_TEAMS_TO_SCORE,
    CATEGORIES.DOUBLE_CHANCE,
    CATEGORIES.FIRST_TEAM_TO_SCORE,
    CATEGORIES.TEAM_WITH_MOST_BOOKING_POINTS,
    CATEGORIES.MATCH_HANDICAP,
];
const marketsConfig = {
    [CATEGORIES.RESULT]: {
        columns: 3,
        rows: 1,
    },
    [CATEGORIES.BOTH_TEAMS_TO_SCORE]: {
        columns: 2,
        rows: 1,
    },
    [CATEGORIES.TOTAL_GOALS]: {
        columns: 2,
        rows: 4,
    },
    [CATEGORIES.TOTAL_GOAL_KICKS]: {
        columns: 2,
        rows: 6,
    },
    [CATEGORIES.TOTAL_CARDS]: {
        columns: 2,
        rows: 4,
    },
    [CATEGORIES.TOTAL_CORNERS]: {
        columns: 2,
        rows: 11,
    },
    [CATEGORIES.DOUBLE_CHANCE]: {
        columns: 3,
        rows: 1,
    },
    [CATEGORIES.TEAM_WITH_MOST_CARDS]: {
        columns: 3,
        rows: 1,
    },
    [CATEGORIES.CORRECT_SCORE]: {
        columns: 3,
        rows: 5,
    },
    [CATEGORIES.PLAYER_FOULS]: {
        columns: 3,
        rows: BYO_MARKET_NO_ROWS,
    },
    [CATEGORIES.PLAYER_OFFSIDES]: {
        columns: 3,
        rows: BYO_MARKET_NO_ROWS,
    },
    [CATEGORIES.PLAYER_TO_SCORE]: {
        columns: 3,
        rows: BYO_MARKET_NO_ROWS,
    },
    [CATEGORIES.PLAYER_TO_SCORE_OUTSIDE_BOX]: {
        columns: 3,
        rows: BYO_MARKET_NO_ROWS,
    },
    [CATEGORIES.PLAYER_TO_SCORE_A_HEADER]: {
        columns: 3,
        rows: BYO_MARKET_NO_ROWS,
    },
    [CATEGORIES.PLAYER_TO_SCORE_LEFT_FOOT]: {
        columns: 3,
        rows: BYO_MARKET_NO_ROWS,
    },
    [CATEGORIES.PLAYER_TO_SCORE_RIGHT_FOOT]: {
        columns: 3,
        rows: BYO_MARKET_NO_ROWS,
    },
    [CATEGORIES.PLAYER_TO_SCORE_A_FREE_KICK]: {
        columns: 3,
        rows: BYO_MARKET_NO_ROWS,
        isNewMarket: process.env.NODE_ENV !== 'production', // New market label to be shown in development and e2e tests only
    },
    [CATEGORIES.PLAYER_TO_SCORE_INSIDE_6_YARD_BOX]: {
        columns: 3,
        rows: BYO_MARKET_NO_ROWS,
    },
    [CATEGORIES.PLAYER_TO_SCORE_OR_ASSIST]: {
        columns: 3,
        rows: BYO_MARKET_NO_ROWS,
    },
    [CATEGORIES.TEAM_WITH_MOST_CORNERS]: {
        columns: 3,
        rows: 1,
    },
    [CATEGORIES.FIRST_TEAM_TO_SCORE]: {
        columns: 3,
        rows: 1,
    },
    [CATEGORIES.COME_FROM_BEHIND]: {
        columns: 3,
        rows: 1,
    },
    [CATEGORIES.TOTAL_BOOKING_POINTS]: {
        columns: 2,
        rows: 5,
    },
    [CATEGORIES.TEAM_WITH_MOST_BOOKING_POINTS]: {
        columns: 3,
        rows: 1,
    },
    [CATEGORIES.MATCH_HANDICAP]: {
        columns: 3,
        rows: 3,
    },
    [CATEGORIES.PLAYER_TO_BE_CARDED]: {
        columns: 3,
        rows: BYO_MARKET_NO_ROWS,
    },
    [CATEGORIES.TOTAL_FREE_KICKS]: {
        columns: 2,
        rows: 6,
    },
    [CATEGORIES.TOTAL_THROW_INS]: {
        columns: 2,
        rows: 6,
    },
    [CATEGORIES.HIGHEST_SCORING_HALF]: {
        columns: 3,
        rows: 1,
    },
    [CATEGORIES.RED_CARD]: {
        columns: 2,
        rows: 1,
    },
    [CATEGORIES.QUALIFY_LIFT_THE_TROPHY]: {
        columns: 2,
        rows: 1,
    },
    [CATEGORIES.PLAYER_TO_ASSIST]: {
        columns: 3,
        rows: BYO_MARKET_NO_ROWS,
    },
    [CATEGORIES.PLAYER_SHOTS]: {
        columns: 3,
        rows: BYO_MARKET_NO_ROWS,
    },
    [CATEGORIES.PLAYER_SHOTS_ON_TARGET]: {
        columns: 3,
        rows: BYO_MARKET_NO_ROWS,
    },
    [CATEGORIES.PLAYER_TOTAL_SHOTS]: {
        columns: 3,
        rows: BYO_MARKET_NO_ROWS,
    },
    [CATEGORIES.PLAYER_TACKLES]: {
        columns: 3,
        rows: BYO_MARKET_NO_ROWS,
    },
    [CATEGORIES.PLAYER_TOTAL_TACKLES]: {
        columns: 3,
        rows: BYO_MARKET_NO_ROWS,
    },
    [CATEGORIES.MATCH_TO_GO_TO_PENALTIES]: {
        columns: 2,
        rows: 1,
    },
    [CATEGORIES.TO_WIN_ON_PENALTIES]: {
        columns: 2,
        rows: 1,
    },
    [CATEGORIES.TOTAL_TACKLES]: {
        columns: 2,
        rows: 4,
    },
    [CATEGORIES.TOTAL_SHOTS]: {
        columns: 2,
        rows: 4,
    },
    [CATEGORIES.TO_WIN_IN_EXTRA_TIME]: {
        columns: 2,
        rows: 1,
    },
    [CATEGORIES.TOTAL_SHOTS_ON_TARGET]: {
        columns: 2,
        rows: 4,
    },
    [CATEGORIES.METHOD_OF_GOAL_HOW]: {
        columns: 3,
        rows: BYO_MARKET_NO_ROWS,
    },
    [CATEGORIES.METHOD_OF_GOAL_WHERE]: {
        columns: 3,
        rows: BYO_MARKET_NO_ROWS,
    },
    [CATEGORIES.QUALIFY]: {
        columns: 2,
        rows: 1,
    },
    [CATEGORIES.MONEY_LINE]: {
        columns: 2,
        rows: 1,
    },
    [CATEGORIES.POINTS_HANDICAP]: {
        columns: 2,
        rows: 4,
        isLineMarket: true,
    },
    [CATEGORIES.TOTAL_POINTS]: {
        columns: 2,
        rows: 4,
    },
    [CATEGORIES.MATCH_2PT_MADE]: {
        columns: 2,
        rows: BYO_MARKET_NO_ROWS,
    },
    [CATEGORIES.MATCH_LOST_FUMBLES]: {
        columns: 2,
        rows: BYO_MARKET_NO_ROWS,
    },
    [CATEGORIES.MATCH_OFFENSE_YARDS]: {
        columns: 2,
        rows: BYO_MARKET_NO_ROWS,
    },
    [CATEGORIES.MATCH_PASSING_YARDS]: {
        columns: 2,
        rows: BYO_MARKET_NO_ROWS,
    },
    [CATEGORIES.MATCH_RUSHING_YARDS]: {
        columns: 2,
        rows: BYO_MARKET_NO_ROWS,
    },
    [CATEGORIES.MATCH_SACKS]: {
        columns: 2,
        rows: BYO_MARKET_NO_ROWS,
    },
    [CATEGORIES.MATCH_TACKLES_ASSISTS]: {
        columns: 2,
        rows: BYO_MARKET_NO_ROWS,
    },
    [CATEGORIES.TEAM_2PT_MADE]: {
        columns: 2,
        rows: BYO_MARKET_NO_ROWS,
    },
    [CATEGORIES.TEAM_DEFENSIVE_TACKLES_AND_ASSISTS]: {
        columns: 2,
        rows: BYO_MARKET_NO_ROWS,
    },
    [CATEGORIES.TEAM_LOST_FUMBLES]: {
        columns: 2,
        rows: BYO_MARKET_NO_ROWS,
    },
    [CATEGORIES.TEAM_OFFENSE_YARDS]: {
        columns: 2,
        rows: BYO_MARKET_NO_ROWS,
    },
    [CATEGORIES.TEAM_PASSING_YARDS]: {
        columns: 2,
        rows: BYO_MARKET_NO_ROWS,
    },
    [CATEGORIES.TEAM_RUSHING_YARDS]: {
        columns: 2,
        rows: BYO_MARKET_NO_ROWS,
    },
    [CATEGORIES.TEAM_SACKS]: {
        columns: 2,
        rows: BYO_MARKET_NO_ROWS,
    },
    [CATEGORIES.TEAM_ASSISTS]: {
        columns: 2,
        rows: BYO_MARKET_NO_ROWS,
    },
    [CATEGORIES.TEAM_THREES_MADE]: {
        columns: 2,
        rows: BYO_MARKET_NO_ROWS,
    },
    [CATEGORIES.TEAM_TURNOVERS]: {
        columns: 2,
        rows: BYO_MARKET_NO_ROWS,
    },
    [CATEGORIES.TEAM_REBOUNDS]: {
        columns: 2,
        rows: BYO_MARKET_NO_ROWS,
    },
    [CATEGORIES.TEAM_STEALS]: {
        columns: 2,
        rows: BYO_MARKET_NO_ROWS,
    },
    [CATEGORIES.TEAM_BLOCKS]: {
        columns: 2,
        rows: BYO_MARKET_NO_ROWS,
    },
    [CATEGORIES.WIN_IN_EXTRA_TIME]: {
        columns: 2,
        rows: 1,
    },
    [CATEGORIES.WIN_ON_PENALTIES]: {
        columns: 2,
        rows: 1,
    },
    [CATEGORIES.PLAYER_TO_BE_SENT_OFF]: {
        columns: 3,
        rows: BYO_MARKET_NO_ROWS,
    },
    'DEFAULT': {
        columns: 3,
        rows: 3,
    },
};
const playerMarkets = new Set([
    'PLAYER_FOULS',
    'PLAYER_OFFSIDES',
    'PLAYER_TO_BE_CARDED',
    'PLAYER_SHOTS',
    'PLAYER_SHOTS_ON_TARGET',
    'PLAYER_TO_SCORE',
    'PLAYER_TO_ASSIST',
    'PLAYER_TACKLES',
    'PLAYER_TO_SCORE_OUTSIDE_BOX',
    'PLAYER_TO_SCORE_A_HEADER',
    'PLAYER_TO_SCORE_LEFT_FOOT',
    'PLAYER_TO_SCORE_RIGHT_FOOT',
    'PLAYER_TO_SCORE_A_FREE_KICK',
    'PLAYER_TO_SCORE_INSIDE_6_YARD_BOX',
    'PLAYER_TO_SCORE_OR_ASSIST',
]);
const playerGridMarketTypes = ['PLAYERLINEBASED', 'PLAYEROUTCOMEYESNO'];
const config = {
    get locale() { var _a, _b; return ((_b = (_a = window.WH) === null || _a === void 0 ? void 0 : _a.i18n) === null || _b === void 0 ? void 0 : _b.locale) || getConfig().locale || 'en-gb'; },
    get eventId() { return getConfig().eventId || ''; },
    get dataServiceUrl() { return getConfig().dataServiceUrl || ''; },
    get tag() { return getConfig().tag || 'byo'; },
    get betslipServiceEndpoint() { return getConfig().betslipServiceEndpoint || ''; },
    get minimumSelections() { return getConfig().minimumSelections || 2; },
    get maximumSelections() { return getConfig().maximumSelections || 12; },
    get defaultOpenAccordions() { return getConfig().defaultOpenAccordions || 0; },
    get locationState() { return getConfig().locationState || 'BYO_APP'; },
    get useBYOFreedom() { return getConfig().useBYOFreedom; },
    get platform() { return getConfig().platform || 'mobile'; },
    get byoFreedomEnabled() { return getConfig().byoFreedomEnabled; },
    get byoMarketsEnabled() { return getConfig().byoMarketsEnabled; },
    marketsConfig,
    disabledSiblingsButtonsOnCategories,
    get byoInPlay() { return getConfig().byoInPlay; },
    playerMarkets,
    playerGridMarketTypes,
    get highlightPriceChangeTime() { var _a; return (_a = getConfig().highlightPriceChangeTime) !== null && _a !== void 0 ? _a : 10000; },
    get showImpactSub() { return getConfig().showImpactSub; },
    maximumLegPartsBySport(sportId) {
        var _a;
        return ((_a = getConfig().maximumLegPartsBySport) === null || _a === void 0 ? void 0 : _a[sportId]) || this.maximumSelections;
    }
};
export default config;
